module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addAsset":"Add asset","addMortgage":"Add mortgage","assetsNotFound":"No assets","mortgagesNotFound":"No mortgages"},"et":{"addAsset":"Add asset","addMortgage":"Add mortgage","assetsNotFound":"No assets","mortgagesNotFound":"No mortgages"},"ru":{"addAsset":"Add asset","addMortgage":"Add mortgage","assetsNotFound":"No assets","mortgagesNotFound":"No mortgages"}}')
  delete Component.options._Ctor
}
